import React, { ErrorInfo, ReactNode } from 'react';
import { logCheckoutError } from './helpers/logCheckoutError';
import CheckoutErrorPage from './components/containers/CheckoutErrorPage';

interface ErrorBoundaryProps {
    children: ReactNode;
}

interface ErrorBoundaryState {
    hasError: boolean;
}

export class CheckoutErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
    static getDerivedStateFromError(): ErrorBoundaryState {
        return { hasError: true };
    }

    constructor(props: ErrorBoundaryProps) {
        super(props);
        this.state = { hasError: false };
    }

    componentDidCatch(error: Error, info: ErrorInfo): void {
        // datadog error reporting
        logCheckoutError(error, 'fatal', { componentStack: info.componentStack });
    }

    render(): ReactNode {
        if (this.state.hasError) {
            return <CheckoutErrorPage />;
        }

        return this.props.children;
    }
}
